import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component, Fragment } from 'react';
import { compose, setDisplayName, withProps } from 'recompose';
import omitProps from '@hocs/omit-props';
import Avatar from '@bubble-ui/molecule-avatar';
import { ColorFunctions as Colors } from '@bubble-ui/particle-colors';
import { withDesignVersion } from '@bubble-ui/provider-design-version';
import wrapOverridableComponent from '@bubble-ui/hoc-wrap-overridable-component';
import View from '@bubble-ui/primitive-view';
import Image from '@bubble-ui/primitive-image';
var BORDER_WIDTH = 1;

var getDefaultStyleSheet = function getDefaultStyleSheet(_ref) {
  var isAvatar = _ref.isAvatar,
      size = _ref.size,
      hasBorderTop = _ref.hasBorderTop,
      designVersion = _ref.designVersion;
  return {
    containerStyle: _objectSpread(_objectSpread({
      borderRadius: size / 2
    }, isAvatar ? {} : {
      backgroundColor: 'white'
    }), {}, {
      width: size,
      height: size,
      overflow: 'hidden'
    }, !isAvatar && hasBorderTop ? {
      borderWidth: 1,
      borderColor: Colors.__shadowMedium(designVersion).toString()
    } : {}),
    borderStyle: {
      position: 'absolute',
      opacity: 0.5,
      top: size / 2,
      bottom: 0,
      width: size,
      height: size / 2,
      borderBottomLeftRadius: size / 2 + BORDER_WIDTH,
      borderBottomRightRadius: size / 2 + BORDER_WIDTH,
      borderColor: Colors.__shadowMedium(designVersion).toString(),
      borderWidth: BORDER_WIDTH,
      borderTop: 0
    },
    imageStyle: {
      objectFit: 'contain',
      height: '100%',
      width: '100%',
      overflow: 'hidden'
    }
  };
};

var DialogIcon = /*#__PURE__*/function (_Component) {
  _inherits(DialogIcon, _Component);

  var _super = _createSuper(DialogIcon);

  function DialogIcon() {
    _classCallCheck(this, DialogIcon);

    return _super.apply(this, arguments);
  }

  _createClass(DialogIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isAvatar = _this$props.isAvatar,
          _this$props$styleShee = _this$props.styleSheet,
          containerStyle = _this$props$styleShee.containerStyle,
          borderStyle = _this$props$styleShee.borderStyle,
          imageStyle = _this$props$styleShee.imageStyle,
          source = _this$props.source,
          _this$props$hasBorder = _this$props.hasBorderTop,
          hasBorderTop = _this$props$hasBorder === void 0 ? true : _this$props$hasBorder;
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(View, {
        style: containerStyle
      }, isAvatar ? /*#__PURE__*/React.createElement(Avatar, {
        large: true,
        icon: source
      }) : /*#__PURE__*/React.createElement(Image, {
        source: source,
        style: imageStyle
      })), !isAvatar && !hasBorderTop && /*#__PURE__*/React.createElement(View, {
        style: borderStyle
      }));
    }
  }]);

  return DialogIcon;
}(Component);

export default compose(setDisplayName('DialogIcon'), withDesignVersion, withProps(function (_ref2) {
  var source = _ref2.source;
  return {
    isAvatar: typeof source !== 'string'
  };
}), wrapOverridableComponent('DialogIcon', getDefaultStyleSheet), omitProps('designVersion'))(DialogIcon);
//# sourceMappingURL=DialogIcon.js.map